import InfoIcon from '@mui/icons-material/Info';
import Logout from '@mui/icons-material/Logout';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import {SxProps} from '@mui/material';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import SettingsIcon from '@mui/icons-material/Settings';

export enum Mode {
  SEARCH_IMAGE = 'searchImage',
  SETTINGS = 'settings'
}

type Props = {
  mode?: Mode,
  onModeChanged: (mode?: Mode) => void
  onAboutClicked: () => void
  onLogout: () => void
}

const Taskbar: FC<Props> = ({
  mode,
  onModeChanged,
  onAboutClicked,
  onLogout,
}) => {
  const {t} = useTranslation();

  const handleModeChanged = (buttonMode: Mode) => onModeChanged(mode === buttonMode ? undefined : buttonMode);

  return <Paper elevation={7} sx={styles.paper}>
    <Stack>
      <Tooltip title={t('button.searchImages')} placement="right">
        <span>
          <IconButton sx={styles.iconButton} onClick={() => handleModeChanged(Mode.SEARCH_IMAGE)}>
            <TravelExploreIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
    <Tooltip title={t('button.settings')} placement="right">
      <IconButton sx={styles.iconButton} onClick={() => handleModeChanged(Mode.SETTINGS)}>
        <SettingsIcon/>
      </IconButton>
    </Tooltip>
    <Divider orientation="horizontal" sx={{width: '80%', mt: 1}}/>
    <Tooltip title={t('button.logout')} placement="right">
      <IconButton sx={styles.iconButton} onClick={onLogout}>
        <Logout/>
      </IconButton>
    </Tooltip>
    <Tooltip title={t('button.about')} placement="right">
      <IconButton sx={styles.iconButton} onClick={onAboutClicked}>
        <InfoIcon/>
      </IconButton>
    </Tooltip>
  </Paper>;
};
export default Taskbar;

const styles: Record<string, SxProps> = {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    outline: '1px solid lightgrey',
    width: '52px',
    borderRadius: '8px',
    opacity: 0.95,
    position: 'absolute',
    top: 'calc(28px + 50%)',
    transform: 'translateY(-50%)',
    left: 8,
    zIndex: 200
  },
  iconButton: {
    my: 1
  },
  selectedIconButton: {
    color:'primary.main'
  }
};
